import React from "react";
import PropTypes from "prop-types";
import DatePicker from "../../../datepicker/DatePicker";
import { Tooltip } from "react-tooltip";
import { IoInformationCircle } from "react-icons/io5";
import { dashboard, tooltipContent } from "../../../../locales/en";
import { formatDateWithDayjs } from "../../../../utils/utils";

const FTNumberCell = ({ value }) => {
  const formattedValue = value;
  return `FT${formattedValue}`;
};
FTNumberCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

const FundAmountCell = ({ value }) => {
  const formattedValue =
    value !== undefined && value !== null && value !== ""
      ? value.toFixed(2)
      : "0.00";
  return `$${formattedValue}`;
};
FundAmountCell.propTypes = {
  value: PropTypes.number
};

const FeeAmountCell = ({ value }) => {
  const formattedValue =
    value !== undefined && value !== null && value !== ""
      ? value.toFixed(2)
      : "0.00";
  return `$${formattedValue}`;
};
FeeAmountCell.propTypes = {
  value: PropTypes.number
};

const DateFundedCell = ({ value }) => {
  if (value) {
    return formatDateWithDayjs(value, "DD-MMM-YYYY");
  } else {
    return "";
  }
};
DateFundedCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

const DueDateCell = ({ value }) => {
  if (value) {
    return formatDateWithDayjs(value, "DD-MMM-YYYY");
  } else {
    return "";
  }
};
DueDateCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

const RepaymentDateCell = ({ value }) => {
  return (
    <DatePicker value={value ? new Date(value) : null} onChange={() => {}} />
  );
};
RepaymentDateCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export const COLUMNS = [
  {
    Header: "Funding Notice",
    Footer: "Funding Notice",
    accessor: "fundingNotice"
  },
  {
    Header: "FT number",
    Footer: "FT number",
    accessor: "demoQuoteId",
    Cell: FTNumberCell
  },
  {
    Header: "Invoice number",
    Footer: "Invoice number",
    accessor: "demoInvoiceNumber"
  },
  {
    Header: "Customer",
    Footer: "Customer",
    accessor: "debtor"
  },
  {
    Header: "Date Funded",
    Footer: "Date Funded",
    accessor: "fundedAt",
    Cell: DateFundedCell
  },
  {
    Header: "Funding Status",
    Footer: "Funding Status",
    accessor: "status"
  },
  {
    Header: "Fund Ammount",
    Footer: "Fund Ammount",
    accessor: "fundingAmount",
    Cell: FundAmountCell
  },
  {
    Header: "Fee Today",
    Footer: "Fee Today",
    accessor: "feeAmount",
    Cell: FeeAmountCell
  },
  {
    Header: "Fee @ Repay Date",
    Footer: "Fee @ Repay Date",
    accessor: "dueDate",
    Cell: DueDateCell
  },
  {
    Header: (
      <>
        <span id="repay-date-tooltip">
          {dashboard.invoiceDatatable.repayDate}
        </span>
        <span
          data-tooltip-id="demoaccColumn"
          className="ms-2"
          data-tooltip-content={tooltipContent.content}
        >
          <IoInformationCircle />
        </span>
        <Tooltip id="demoaccColumn" className="report_tooltip" />
      </>
    ),
    Footer: "Repay Date",
    accessor: "repaymentDate",
    Cell: RepaymentDateCell
  }
];
